
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","data-token-name":"send"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#a)","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M2.3 13.024a1.387 1.387 0 01-.736-2.562L16.967.833a1.386 1.386 0 012.096 1.434l-3 15.977a1.386 1.386 0 01-2.471.576L9.25 13.024H2.3z"}}),_c('path',{attrs:{"d":"M9.25 13.024H7.167v4.31a1.386 1.386 0 002.166 1.144l2.649-1.805-2.732-3.649zm0 0L18.482.866"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"currentColor","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    